module.exports = __webpack_public_path__ + "static/img/image@2x (2).1d3ca00b.png";